import { render, staticRenderFns } from "./FormCreateKra.vue?vue&type=template&id=621eef2c&scoped=true"
import script from "./FormCreateKra.vue?vue&type=script&lang=js"
export * from "./FormCreateKra.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "621eef2c",
  null
  
)

export default component.exports